import {
  OFFER_TYPES,
} from 'utils/constants';
import { createRedirectLink } from 'utils/routing';
import { generateWatchLocation } from 'utils/helpers';

export const MSG_IDS = {
  [OFFER_TYPES.SubscribeType]: 'checkout.subscriptionOffers',
  [OFFER_TYPES.RentType]: 'checkout.rentOffers',
  [OFFER_TYPES.BuyType]: 'checkout.buyOffers',
  [OFFER_TYPES.PassType]: 'checkout.passOffers',
};

export const generateCheckoutConfLocation = (offerId, viewable, redirectTo, promoCode) => ({
  name: 'checkout-confirmation',
  query: {
    packageId: offerId,
    redirectTo: redirectTo || createRedirectLink(generateWatchLocation(viewable)),
    ...(promoCode ? { promoCode } : null),
  },
});

export const getOffer = (offerId, offers) => offers.find(i => i.id === offerId);

// returns most expensive offer
export const mostExpensiveOffer = (offers) => {
  if (!offers?.length) return undefined;

  // Filter for subscription offers
  const subscriptionOffers = offers.filter(o => o.__typename === OFFER_TYPES.SubscribeType);
  let offer;
  if (subscriptionOffers.length) {
    offer = subscriptionOffers.reduce(
      (res, o) => o.priceInCents > res.priceInCents ? o : res,
    );
  } else {
    offer = offers[0];
  }
  return offer;
};
